import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AutoComplete } from "antd";
// import { formatNumber } from "../../../../components/formatNumber";

export const formatNumber = (num) => {
  if (num === null || num === undefined || num === "") return "0.00";

  const number = Number(num);

  if (isNaN(number)) return num;

  return number.toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};


const FarmerProductwiseGoodsIssueReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const [totalCount, setTotalCount] = useState(0);
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [ranchId, setRanchId] = useState();
  const [ranchData, setRanchData] = useState([]);
  const [fieldName, setFieldName] = useState("");
  const [fieldOptions, setFieldOptions] = useState([]);
  const [cropId, setCropId] = useState("");
  const [cropFilterList, setCropFilterList] = useState([]);

  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [showDateFilter, setShowDateFilter] = useState(false);
  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const { sendRequest: getWarehouseData } = useHttp();
  const { sendRequest: getSeasonList } = useHttp();
  const { sendRequest: getCropList } = useHttp();

  useEffect(() => {
    getCropList(
      {
        url: `/api/farmerCropList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        setCropFilterList(res?.output);
      }
    );
  }, [getCropList]);

  const [seasonId, setSeasonId] = useState("");
  const [seasonData, setSeasonData] = useState([]);




  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleFDateChange = (e) => {
    // console.log("handleFDateChange",e.target.value)
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  // var date =date.setDate(date.getDate() + 10);

  const [currencyCode, setCurrencyCode] = useState("");

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 90);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate",toDate)

  const [selectedToDate, setSelectedToDate] = useState(toDate);




  const { sendRequest: getprocurementData } = useHttp();

  const loadCountData = (id) => {
    fillprocurementData(id);
  };

  const fillprocurementData = (employeeId, regionId) => {
    var urlfilter = "";

    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNumber !== "") urlfilter += `&farmerNo=${farmerNumber}`;

    if (ranchId > 0) {
      urlfilter = urlfilter + `&ranchId=${ranchId}`;
    }
    if (fieldName && fieldName !== "") {
      urlfilter += `&fieldId=${fieldName}`;
    }

    if (seasonId) {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }
    if (cropId !== "") {
      urlfilter += `&cropId=${cropId}`;
    }

    if (showDateFilter) {
      urlfilter += `&fromDate=${moment(selectedFromDate).format("DD/MM/YYYY")}`;
      urlfilter += `&toDate=${moment(selectedToDate).format("DD/MM/YYYY")}`;
    }


    // urlfilter += `&fromDate=${moment(selectedFromDate).format("DD/MM/YYYY")}`;
    // urlfilter += `&toDate=${moment(selectedToDate).format("DD/MM/YYYY")}`;

    var url = `/api/goodsIssueProductReport/?page=${currentPage}&page_size=${itemsPerPage}&orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getprocurementData({ url: url }, (res) => {
      setData(res?.results?.data || []);
      setTotalCount(res?.count || 0);
    });
  };

  const { sendRequest: getRanch } = useHttp();
  useEffect(() => {
    getRanch(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchData(data);
      }
    );
  }, [getRanch]);

  useEffect(() => {
    setCurrentPage(1);
    fillprocurementData(employeeId, regionId);
  }, [
    seasonId,
    employeeId,
    cropId,
    ranchId,
    fieldName,
    farmerNumber,
    selectedFromDate,
    selectedToDate,
    showDateFilter,
  ]);

  useEffect(() => {
    fillprocurementData(employeeId, regionId);
  }, [currentPage]);


  useEffect(() => {

    if (!ranchId || ranchId === 0) {
      setFieldOptions([]);
      return;
    }

    const selectedRanch = ranchData.find(
      (x) => String(x.ranchId) === String(ranchId)
    );

    if (!selectedRanch) {
      return;
    }

    const filteredData = data.filter(
      (item) => item.ranchName === selectedRanch.ranchName
    );

    const uniqueFields = [
      ...new Set(
        filteredData
          .map((item) => item.fieldName)
          .filter(Boolean)
      ),
    ];

    const fieldList = uniqueFields.map((f) => ({
      fieldName: f,
    }));

    setFieldOptions(fieldList);

  }, [ranchId, data, ranchData]);

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("region", data);

        setRegionData(data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    var url = "";
    if (employeeId > 0) {
      url = url + '&fieldExecutiveId=' + employeeId;
    }

    if (seasonId > 0) {
      url = url + '&seasonId=' + seasonId;
    }

    if (ranchId > 0) {
      url = url + '&ranchId=' + ranchId;
    }


    getFarmerNumber(
      {
        url: `/api/goodsIssueFarmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}${url}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [getFarmerNumber, employeeId, ranchId, seasonId]);

  const handleSearch = (value) => {
    setFarmerNumber(value);

  };

  useEffect(() => {
    getSeasonList(
      { url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}` },
      (data) => {
        setSeasonData(data);   // ✅ Works now
      }
    );
  }, [getSeasonList]);


  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  const fieldsToExport = [
    "farmerName",
    "farmerCode",
    "executiveName",
    "ranchName",
    "fieldName",
    "plotName",
    "cropName",
    // "regionName",
    "goodsIssueDate",
    "productName",
    "useQty",
    "unit",
    "salesRate",
    "useAmt",
  ];

  const customHeaders = [
    "Farmer Name",
    "Farmer Code",
    "Executive Name",
    "Ranch Name",
    "Field Name",
    "Plot No",
    "Crop Name",
    // "Region Name",
    "Goods Issue Date",
    "Product Name",
    "Quantity",
    "Unit",
    "Sales Rate",
    "Total Amount",
  ];
  const handleExportExcel = () => {

    let urlfilter = "";

    if (employeeId > 0) {
      urlfilter += `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter += `&regionId=${regionId}`;
    }

    if (farmerNumber !== "") {
      urlfilter += `&farmerNo=${farmerNumber}`;
    }

    if (ranchId > 0) {
      urlfilter += `&ranchId=${ranchId}`;
    }

    if (fieldName && fieldName !== "") {
      urlfilter += `&fieldId=${fieldName}`;
    }

    if (seasonId) {
      urlfilter += `&seasonId=${seasonId}`;
    }

    if (cropId !== "") {
      urlfilter += `&cropId=${cropId}`;
    }

    if (showDateFilter) {
      urlfilter += `&fromDate=${moment(selectedFromDate).format("DD/MM/YYYY")}`;
      urlfilter += `&toDate=${moment(selectedToDate).format("DD/MM/YYYY")}`;
    }

    const exportUrl = `/api/goodsIssueProductReport/?isExport=true&orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getprocurementData({ url: exportUrl }, (res) => {

      console.log("EXPORT RESPONSE", res);

      const exportData =
        res?.data ||
        res?.results?.data ||
        [];

      if (!exportData.length) {
        toast.error("No data available to export!");
        return;
      }

      convertToExcel(
        exportData,
        fieldsToExport,
        "FarmerGoodsIssuedReport.xlsx",
        customHeaders
      );
    });
  };


  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Product Input Loan Detail
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <hr />

            <div className="row">
              <div className="col-md-3">
                <label>Crop Name</label>

                <select
                  className="form-control"
                  value={cropId}
                  onChange={(e) => {
                    setCropId(e.target.value);
                  }}
                >
                  <option value="">Select</option>

                  {cropFilterList &&
                    cropFilterList.map((x) => (
                      <option key={x.CropId} value={x.CropId}>
                        {x.CropName}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                <label>Season Name</label>
                <select
                  className="form-control"
                  value={seasonId}
                  onChange={(e) => {
                    setSeasonId(+e.target.value || 0);

                  }}
                >
                  <option value="0">--Select--</option>

                  {seasonData.map((x) => (
                    <option key={x.seasonId} value={x.seasonId}>
                      {x.seasonName}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-md-3">
                <div className="form-group">
                  <label>Ranch</label>
                  <select
                    id="ranch"
                    className="form-control"
                    value={ranchId}
                    onChange={(e) => {
                      setRanchId(e.target.value || 0);
                      setFieldName("");

                    }}
                  >
                    <option value="">Select</option>
                    {ranchData &&
                      ranchData.map((x) => (
                        <option key={x.ranchId} value={x.ranchId}>
                          {x.ranchName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Field Name</label>
                  <select
                    className="form-control"
                    value={fieldName}
                    onChange={(e) => {
                      setFieldName(e.target.value);
                    }}
                  >
                    <option value="">Select</option>

                    {fieldOptions.map((x, i) => (
                      <option key={i} value={x.fieldName}>
                        {x.fieldName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* <div className="col-md-3">
                <label>Field Officer</label>
                <select
                  className="form-control"
                  value={employeeId}
                  onChange={(e) => {
                    setEmployeeId(+e.target.value || 0);
                    setData([]);
                  }}
                >
                  <option value="0">--Select--</option>
                  {employeeData.map((x) => (
                    <option key={x.userId} value={x.userId}>
                      {x.employeeName}
                    </option>
                  ))}
                </select>
              </div> */}







              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>
              {/* Date Filter */}
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillprocurementData(employeeId, regionId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center table-responsive">
                      {/* <table className="table table-bordered table-responsive text-center table-sm"> */}
                      <thead>
                        <tr className="table-header">
                          <th>Farmer No</th>
                          <th>Farmer Name</th>

                          <th>Field Officer</th>
                          <th>Ranch Name</th>
                          <th>Field Name</th>
                          <th>Plot No.</th>
                          <th>Crop Name</th>
                          <th>Season Name</th>
                          {/* <th> Region Name</th> */}
                          <th> Goods Issue Date</th>
                          <th> Product Name </th>
                          <th> Quantity</th>
                          <th> Unit</th>
                          <th> Sales Rate</th>
                          <th> Total Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {data &&
                          data.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.farmerCode}</td>
                                <td>{itm.farmerName}</td>

                                <td>{itm.executiveName}</td>
                                <td>{itm.ranchName}</td>
                                <td>{itm.fieldName}</td>
                                <td>{itm.plotName}</td>
                                <td>{itm.cropName}</td>
                                <td>{itm.seasonName}</td>
                                {/* <td>{itm.regionName}</td> */}

                                <td>{itm.goodsIssueDate}</td>
                                <td>{itm.productName}</td>
                                <td>{itm.useQty}</td>
                                <td>{itm.unit}</td>
                                <td>{parseFloat(itm.salesRate).toFixed(2)}</td>
                                <td>
                                  {" "}
                                  {formatNumber(itm.useAmt || 0)}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={totalCount}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerProductwiseGoodsIssueReport;
